
const state = {
    items: [],
    isCartOpen: false
}
const mutations = {
    ADD_TO_CART(state, { product, quantity = 1 }) {
        const existingItem = state.items.find(item => item.id === product.id)

        if (existingItem) {
            existingItem.quantity += quantity
        } else {
            state.items.push({
                ...product,
                quantity
            })
        }
    },
    REMOVE_FROM_CART(state, productId) {
        state.items = state.items.filter(item => item.id !== productId)
    },
    UPDATE_QUANTITY(state, { productId, quantity }) {
        const item = state.items.find(item => item.id === productId)
        if (item) {
            item.quantity = quantity
        }
    },
    CLEAR_CART(state) {
        state.items = []
    },
    TOGGLE_CART(state) {
        state.isCartOpen = !state.isCartOpen
    },
    SET_CART_OPEN(state, isOpen) {
        state.isCartOpen = isOpen
    }
}
const actions = {
    addToCart({ commit }, { product, quantity = 1 }) {
       
        const tokenInStorage = localStorage.getItem("access_token");

        if (!tokenInStorage) {
            commit('SET_OTP_MODAL', true, { root: true })
            return
        }

            commit('ADD_TO_CART', { product, quantity })
        
    },
    removeFromCart({ commit }, productId) {
        commit('REMOVE_FROM_CART', productId)
    },
    updateQuantity({ commit }, { productId, quantity }) {
        commit('UPDATE_QUANTITY', { productId, quantity })
    },
    toggleCart({ commit }) {
        commit('TOGGLE_CART')
    }
}
const getters = {
    cartItems: (state) => state.items,
    cartTotal: (state) => {
        return state.items.reduce((total, item) => {
            const price = item.price * (1 - (item.discount || 0) / 100)
            return total + (price * item.quantity)
        }, 0).toFixed(2)
    },
    cartItemCount: (state) => {
        return state.items.reduce((count, item) => count + item.quantity, 0)
    },
    isCartOpen: (state) => state.isCartOpen
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}